import styled from 'styled-components';
import { Colors } from '../../../../constants/Colors';

export const HeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
`;

export const Subtle = styled.div`
    font-size: 14px;
    color: ${Colors?.commons?.darkGray || '#666'};
`;
